import { render, staticRenderFns } from "./UpdatesBadge.vue?vue&type=template&id=4312ef95&"
import script from "./UpdatesBadge.vue?vue&type=script&lang=js&"
export * from "./UpdatesBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports